import styled from "styled-components";

export const Inner = styled.div`
	padding: 20px;
`;

export const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
	gap: 20px;
	padding-top: 20px;
`;

export const Card = styled.div`
	background: white;
	padding: 20px;
	border-radius: 8px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	display: flex;
	flex-direction: column;
	justify-content: space-between;
`;

export const Label = styled.div`
	font-weight: bold;
	margin-bottom: 16px;
	color: #222;
`;

export const Row = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	margin-bottom: 8px;
`;

export const Circle = styled.div`
	width: 16px;
	height: 16px;
	border-radius: 50%;
	background-color: ${(props) => props.color || "#ccc"};
`;

export const Controls = styled.div`
	display: flex;
	justify-content: flex-end;
	margin-bottom: 16px;
`;
